import { render, staticRenderFns } from "./imgalign.vue?vue&type=template&id=76117910&scoped=true&lang=pug&"
import script from "./imgalign.vue?vue&type=script&lang=js&"
export * from "./imgalign.vue?vue&type=script&lang=js&"
import style0 from "./imgalign.vue?vue&type=style&index=0&id=76117910&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76117910",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('76117910', component.options)
    } else {
      api.reload('76117910', component.options)
    }
    module.hot.accept("./imgalign.vue?vue&type=template&id=76117910&scoped=true&lang=pug&", function () {
      api.rerender('76117910', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form_element/imgalign.vue"
export default component.exports